// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as getListMaestroReducer } from './getListMaestro';
import { reducer as searchDataMasterReducer } from './searchDataMaster';
import { reducer as loadSchemasFromMaestroReducer } from './loadSchemasFromMaestro';
import { reducer as loadSchemaCategoriesReducer } from './loadSchemaCategories';
import { reducer as getBrandsReducer } from './getBrands';
import { reducer as updateBrandReducer } from './updateBrand';
import { reducer as updateBrandListReducer } from './updateBrandList';
import { reducer as createBrandReducer } from './createBrand';
import { reducer as getModelsReducer } from './getModels';
import { reducer as updateModelListReducer } from './updateModelList';
import { reducer as updateModelReducer } from './updateModel';
import { reducer as createModelReducer } from './createModel';
import { reducer as deleteBrandReducer } from './deleteBrand';
import { reducer as deleteModelReducer } from './deleteModel';
import { reducer as createCompanyReducer } from './createCompany';
import { reducer as deleteCompanyReducer } from './deleteCompany';
import { reducer as getCompaniesReducer } from './getCompanies';
import { reducer as updateCompanyReducer } from './updateCompany';
import { reducer as updateCompanyListReducer } from './updateCompanyList';
import { reducer as createVersionReducer } from './createVersion';
import { reducer as deleteVersionReducer } from './deleteVersion';
import { reducer as getVersionsReducer } from './getVersions';
import { reducer as updateVersionReducer } from './updateVersion';
import { reducer as updateVersionListReducer } from './updateVersionList';
import { reducer as getModelsByBrandReducer } from './getModelsByBrand';
import { reducer as createCarDealershipReducer } from './createCarDealership';
import { reducer as deleteCarDealershipReducer } from './deleteCarDealership';
import { reducer as getCarDealershipsReducer } from './getCarDealerships';
import { reducer as updateCarDealershipReducer } from './updateCarDealership';
import { reducer as updateCarDealershipListReducer } from './updateCarDealershipList';
import { reducer as validateCuitCarDealershipReducer } from './validateCuitCarDealership';
import { reducer as createBranchReducer } from './createBranch';
import { reducer as deleteBranchReducer } from './deleteBranch';
import { reducer as getBranchesReducer } from './getBranches';
import { reducer as updateBranchReducer } from './updateBranch';
import { reducer as updateBranchListReducer } from './updateBranchList';
import { reducer as validateCuitBranchReducer } from './validateCuitBranch';
import { reducer as createLocationReducer } from './createLocation';
import { reducer as deleteLocationReducer } from './deleteLocation';
import { reducer as getLocationsReducer } from './getLocations';
import { reducer as updateLocationReducer } from './updateLocation';
import { reducer as getBranchesByCarDealershipReducer } from './getBranchesByCarDealership';
import { LOGOUT_USER } from '../../common/redux/constants'
import { reducer as createBusinessUnitReducer } from './createBusinessUnit';
import { reducer as deleteBusinessUnitReducer } from './deleteBusinessUnit';
import { reducer as getBusinessUnitsReducer } from './getBusinessUnits';
import { reducer as updateBusinessUnitReducer } from './updateBusinessUnit';
import { reducer as canDeleteModelReducer } from './canDeleteModel';
import { reducer as createLegalDocReducer } from './createLegalDoc';
import { reducer as deleteLegalDocReducer } from './deleteLegalDoc';
import { reducer as getLegalDocsReducer } from './getLegalDocs';
import { reducer as getLegalDocTypesReducer } from './getLegalDocTypes';
import { reducer as updateLegalDocReducer } from './updateLegalDoc';
import { reducer as createBankAccountReducer } from './createBankAccount';
import { reducer as deleteBankAccountReducer } from './deleteBankAccount';
import { reducer as getBankAccountsReducer } from './getBankAccounts';
import { reducer as getFinancialEntitiesReducer } from './getFinancialEntities';
import { reducer as updateBankAccountReducer } from './updateBankAccount';
import { reducer as getCurrenciesReducer } from './getCurrencies';
import { reducer as getISOCurrenciesReducer } from './getISOCurrencies';
import { reducer as getExchangeRatesReducer } from './getExchangeRates';
import { reducer as deleteExchangeRateReducer } from './deleteExchangeRate';
import { reducer as createExchangeRateReducer } from './createExchangeRate';
import { reducer as updateExchangeRateReducer } from './updateExchangeRate';
import { reducer as getGrantingEntitiesReducer } from './getGrantingEntities';
import { reducer as deleteGrantingEntityReducer } from './deleteGrantingEntity';
import { reducer as createGrantingEntityReducer } from './createGrantingEntity';
import { reducer as updateGrantingEntityReducer } from './updateGrantingEntity';
import { reducer as createCurrencyReducer } from './createCurrency';
import { reducer as deleteCurrencyReducer } from './deleteCurrency';
import { reducer as updateCurrencyReducer } from './updateCurrency';
import { reducer as getProvincesReducer } from './getProvinces';
import { reducer as getPaymentMethodsReducer } from './getPaymentMethods';
import { reducer as getPayCompanyReducer } from './getPayCompany';
import { reducer as getPayBranchOfficesReducer } from './getPayBranchOffices';
import { reducer as getExcelPricesReducer } from './getExcelPrices';
import { reducer as getExcelLatestUpdatesReducer } from './getExcelLatestUpdates';
import { reducer as uploadExcelPricesReducer } from './uploadExcelPrices';
import { reducer as createYearlyPercentageRate } from './createYearlyPercentageRate';
import { reducer as updatePercentageRateReducer } from './updatePercentageRate';
import { reducer as updateDepreciationYearReducer } from './updateDepreciationYear';
import { reducer as updateDepreciationSelectedModelReducer } from './updateDepreciationSelectedModel';
import { reducer as updateVersionPivotReducer } from './updateVersionPivot';
import { reducer as updateVersionPriceReducer } from './updateVersionPrice';
import { reducer as setPricesDraftDataReducer } from './setPricesDraftData';

const reducers = [
  getListMaestroReducer,
  searchDataMasterReducer,
  loadSchemasFromMaestroReducer,
  loadSchemaCategoriesReducer,
  getBrandsReducer,
  updateBrandReducer,
  updateBrandListReducer,
  createBrandReducer,
  getModelsReducer,
  updateModelListReducer,
  updateModelReducer,
  createModelReducer,
  deleteBrandReducer,
  deleteModelReducer,
  createCompanyReducer,
  deleteCompanyReducer,
  getCompaniesReducer,
  updateCompanyReducer,
  updateCompanyListReducer,
  createVersionReducer,
  deleteVersionReducer,
  getVersionsReducer,
  updateVersionReducer,
  updateVersionListReducer,
  getModelsByBrandReducer,
  createCarDealershipReducer,
  deleteCarDealershipReducer,
  getCarDealershipsReducer,
  updateCarDealershipReducer,
  updateCarDealershipListReducer,
  validateCuitCarDealershipReducer,
  createBranchReducer,
  deleteBranchReducer,
  getBranchesReducer,
  updateBranchReducer,
  updateBranchListReducer,
  validateCuitBranchReducer,
  createLocationReducer,
  deleteLocationReducer,
  getLocationsReducer,
  updateLocationReducer,
  getBranchesByCarDealershipReducer,
  createBusinessUnitReducer,
  deleteBusinessUnitReducer,
  getBusinessUnitsReducer,
  updateBusinessUnitReducer,
  canDeleteModelReducer,
  createLegalDocReducer,
  deleteLegalDocReducer,
  getLegalDocsReducer,
  getLegalDocTypesReducer,
  updateLegalDocReducer,
  createBankAccountReducer,
  deleteBankAccountReducer,
  getBankAccountsReducer,
  getFinancialEntitiesReducer,
  updateBankAccountReducer,
  getCurrenciesReducer,
  getISOCurrenciesReducer,
  getExchangeRatesReducer,
  deleteExchangeRateReducer,
  createExchangeRateReducer,
  updateExchangeRateReducer,
  getGrantingEntitiesReducer,
  deleteGrantingEntityReducer,
  createGrantingEntityReducer,
  updateGrantingEntityReducer,
  createCurrencyReducer,
  deleteCurrencyReducer,
  updateCurrencyReducer,
  getProvincesReducer,
  getPaymentMethodsReducer,
  getPayCompanyReducer,
  getPayBranchOfficesReducer,
  getExcelPricesReducer,
  getExcelLatestUpdatesReducer,
  uploadExcelPricesReducer,
  createYearlyPercentageRate,
  updatePercentageRateReducer,
  updateDepreciationYearReducer,
  updateDepreciationSelectedModelReducer,
  updateVersionPivotReducer,
  updateVersionPriceReducer,
  setPricesDraftDataReducer
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    case LOGOUT_USER:
      newState = initialState;
      break;
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
